export default __webpack_public_path__ + "static/media/invitation.388c777e.svg";